import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { allSharedComponents } from "../../../shared";
import { setLocalStorageItem, setSessionStorageItem } from "../../../system";
import CustomModal from "../../../shared/components/CustomModal/CustomModal";
import {
  roles,
  StorageKeys,
  viewPathConstants,
  translationConstants,
  contactEmail,
} from "../../../constants";
import { authActions } from "../../../redux/actions";

const { GeneralLogo, BaseForm } = allSharedComponents;

const DisabledInstructorModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [isShow, setShow] = useState(true);
  const navigate = useNavigate();
  const onSetShow = () => {
    setShow((prev) => !prev);
    setLocalStorageItem(StorageKeys.activeRole, roles.Practioner);
    dispatch(authActions.setActiveProfile(roles.Practioner));
    navigate(viewPathConstants.DEFAULT_PATH);
  };

  return (
    <div className="EmailApprovalContainer">
      <CustomModal
        size="sm"
        scrollable={true}
        setShow={onSetShow}
        show={isShow}
        closeBtnClasses={"login-modal-close-btn"}
      >
        <BaseForm>
          <GeneralLogo />
          <p className="UnderView">
            {t(translationConstants.DISABLED_INSTRUCTOR_MSG)}
          </p>
          <span className="GoBackPara">
            {t(translationConstants.PLEASE_CONTACT_US_AT)}{" "}
            <a
              href={`mailto:${contactEmail}?subject=Inquiry`}
              target="_blank"
              className="text-decoration-underline"
            >
              {contactEmail}
            </a>
          </span>
        </BaseForm>
      </CustomModal>
    </div>
  );
};

export default DisabledInstructorModal;
